export default __webpack_public_path__ + "flickr-website-logo-silhouette.png";